<template>
  <div :class="['tva-accordion']">
    <div
      v-for="(item, itemIndex) in content"
      :key="itemIndex"
      :class="['tva-accordion-item', { open: open }]"
      @click="toggleAccordion(itemIndex)"
    >
      <div
        :class="[
          'tva-accordion-item-title',
          { closed: isSectionClosed(itemIndex) }
        ]"
      >
        {{ item.title }}
        <svgicon
          class="tva-accordion-item-arrow"
          icon="actions-navigation-chevron-up"
          width="20"
          height="20"
        ></svgicon>
      </div>
      <div
        :class="[
          'tva-accordion-item-paragraph',
          'accordion-entry-content',
          'normal',
          'white',
          { closed: isSectionClosed(itemIndex) }
        ]"
        v-html="item.paragraph"
      ></div>
    </div>
  </div>
</template>
<script>
import "@/compiled-icons/actions-navigation-chevron-up";
export default {
  props: ["content"],
  data() {
    return {
      open: false,
      openSections: new Set([]),
      heightEvaluated: false
    };
  },
  mounted() {
    const accordionEntry = document.querySelectorAll(
      ".accordion-entry-content"
    );
    accordionEntry.forEach(el => {
      el.style.height = el.clientHeight + "px";
    });
    this.heightEvaluated = true;
  },
  methods: {
    toggleAccordion(index) {
      let tmpOpenSections = _.clone(this.openSections);
      if (tmpOpenSections.has(index)) {
        tmpOpenSections.delete(index);
      } else {
        tmpOpenSections.add(index);
      }
      this.openSections = _.clone(tmpOpenSections);
    },
    isSectionClosed(index) {
      return !this.openSections.has(index) && this.heightEvaluated;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/fonts.scss";
.tva-accordion {
  .tva-accordion-item {
    overflow: hidden;
    transition: all 0.3s ease;
    &-title {
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1em;
      transition: all 0.1s ease;
      cursor: pointer;
      user-select: none;
      .tva-accordion-item-arrow {
        transition: all 0.2s ease;
      }
      &.closed {
        .tva-accordion-item-arrow {
          transform: rotate(-180deg);
        }
      }
    }
    &-paragraph {
      padding: 1em;
      transition: all 0.4s ease-in-out;
      &.closed {
        height: 0 !important;
        padding: 0 1em;
      }
    }
  }
}
</style>
